import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const BackIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export default function LegalLayout({ badge, title, date, children }) {
  const year = new Date().getFullYear();
  return (
    <>
      <nav className="legal-nav">
        <div className="legal-nav-inner">
          <Link to="/" className="legal-nav-logo">Clockeo</Link>
          <Link to="/" className="legal-nav-back">
            <BackIcon /> Retour à l'accueil
          </Link>
        </div>
      </nav>

      <div className="legal-wrapper">
        <div className="legal-header">
          <div className="legal-badge">{badge}</div>
          <h1 className="legal-title">{title}</h1>
          <p className="legal-date">{date}</p>
        </div>
        {children}
      </div>

      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <p className="legal-footer-copy">© {year} Clockeo. Tous droits réservés.</p>
          <div className="legal-footer-links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/cgu">CGU</Link>
            <Link to="/confidentialite">Confidentialité</Link>
          </div>
        </div>
      </footer>
    </>
  );
}
